<template>
  <div class="productDetails" :class="{ 'productDetails--outlet': outlet }">
    <div v-if="outlet" class="productDetails__outlet">
      <div class="productDetails__outletTitle">Wariant OUTLET - Niższa cena</div>
      <div class="productDetails__outletDescription">{{ outlet.description }}</div>
    </div>
    <ul class="productDetails__list">
      <li
        v-for="(item, index) in list"
        :key="index"
        class="productDetails__item"
        :class="{
          'productDetails__item--hide': index > collapseCount - 1 && !isCollapse,
        }"
      >
        <span class="productDetails__itemName">{{ item.name }}:</span>
        <nuxt-link
          v-if="item.urlParams && item.urlParams.key"
          :to="localePath({ name: 'ats-slug', params: { slug: item.urlParams.key } })"
          class="productDetails__itemLink"
        >
          <span class="productDetails__itemLinkText productDetails__itemLinkText--link">{{
            item.value
          }}</span>
        </nuxt-link>
        <span v-else class="productDetails__itemValue">{{ item.value }}</span>
      </li>
    </ul>
    <button
      v-if="list.length > collapseCount && !isCollapse"
      class="productDetails__toggle"
      @click="toggle"
    >
      <span class="productDetails__toggleIcon" />
      <span class="productDetails__toggleText">pokaż więcej</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ProductDetails',
  props: {
    list: {
      type: Array,
      default: () => {},
    },
    collapseCount: {
      type: Number,
      default: 10,
    },
    outlet: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isCollapse: false,
    };
  },
  methods: {
    toggle() {
      this.isCollapse = this.isCollapse !== true;
    },
  },
};
</script>

<style lang="scss">
.productDetails {
  $root: &;

  &--outlet.productHeader__details {
    border-top: unset;
    padding-top: 0.6rem;
  }

  &__item {
    font-size: 1.4rem;
    line-height: 2.4rem;

    &--hide {
      display: none;
    }
  }

  &__itemName {
    color: $cAddDark02;
  }

  &__toggle {
    display: flex;
    align-items: center;

    &:hover {
      #{$root}__toggleText {
        color: $cSec;
      }
    }
  }

  &__toggleIcon {
    position: relative;
    margin-top: 7px;
    margin-right: 1rem;
    display: inline-flex;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    border: 1px solid $cAddLight;
    transition: border-color $tr;

    &:after {
      @include icomoon('chevron-down');
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 6px;
      color: $cMainLight;
    }
  }

  &__toggleText {
    font-size: 1.3rem;
    line-height: 2rem;
    color: $cMain;
    text-decoration: underline;
    transition: color $tr;
  }

  &__itemLinkText {
    &--link {
      text-decoration: underline;
      transition: opacity $tr;

      &:hover {
        opacity: 0.7;
      }
    }
  }

  &__outlet {
    margin-bottom: 1.6rem;
    background: rgba(255, 110, 0, 0.1);
    padding: 1rem 1.6rem;
    font-size: 1.4rem;
    line-height: 1.4;
  }

  &__outletTitle {
    font-weight: 700;
  }
}
</style>
